<template>
	<!-- 我的投资订单页面 -->
	<div class="order_wrap">
		<!-- 顶部导航栏 -->
		<div class="red_top_bg">
			<div class="back_left" @click="$router.back()"></div>
			<div class="big_tit">{{ $t('user.myInvestment') }}</div>
		</div>

		<!-- 数据统计卡片 -->
		<div class="stats_card">
			<div class="stat_item">
				<div class="stat_value">{{ data.on_money || '0.00' }}</div>
				<div class="stat_label">{{ $t('user.uncollectedPrincipal') }}</div>
			</div>
			<div class="stat_item">
				<div class="stat_value">{{ data.on_apr_money || '0.00' }}</div>
				<!-- <div class="stat_label">{{ $t('user.uncollectedInterest') }}</div> -->
				<div class="stat_label">已收奖励</div>
			</div>
			<!-- <div class="stat_item">
				<div class="stat_value">{{ data.ok_apr_money || '0.00' }}</div>
				<div class="stat_label">{{ $t('user.cumulativeIncome') }}</div>
			</div> -->
		</div>

		<!-- 订单列表 -->
		<div class="order_section">
			<div class="section_title">
				<van-icon name="orders-o" />
				<span>{{ $t('orders.record') }}</span>
			</div>

			<!-- 空状态 -->
			<van-empty :description="$t('orders.noOrders')" v-if="empty" />

			<!-- 订单列表 -->
			<div class="order_list" v-else>
				<div class="order_item" v-for="(item, index) in data.list" :key="index">
					<!-- 订单头部：时间和状态 -->
					<div class="order_header">
						<div class="order_time">{{ item.time }}</div>
						<div class="order_status" :class="item.status == 0 ? 'pending' : 'completed'">
							{{ item.status == 0 ? $t('orders.unfinish') : $t('orders.finish') }}
						</div>
					</div>

					<!-- 订单内容 -->
					<div class="order_content">
						<div class="order_icon">
							<img v-if="item.cover" :src="item.cover" alt="">
							<img v-else src="../images/new/icons8-silver-bars-100.png" alt="">
						</div>
						<div class="order_info">
							<div class="order_name">{{ item[lang] }}</div>
							<div class="order_stats">
								<div class="stat">
									<div class="stat_num">{{ item.money }}</div>
									<div class="stat_desc">{{ $t('utils.investmentAmount') }}</div>
								</div>
								<div class="stat">
									<div class="stat_num income">{{ item.shouyi.toFixed(2) }}</div>
									<div class="stat_desc">积分</div>
								</div>
								<div class="stat" v-if="item.status == 1">
									<div class="stat_num">{{ item.day }}{{ $t('utils.day') }}</div>
									<div class="stat_desc">{{ $t('utils.cycle') }}</div>
								</div>
								<div class="stat" v-if="item.status == 0">
									<van-count-down :time="item.left_time * 1000" class="countdown">
										<template #default="timeData">
											<span class="countdown_block">{{ timeData.days }}</span>
											<span class="countdown_colon">:</span>
											<span class="countdown_block">{{ timeData.hours }}</span>
											<span class="countdown_colon">:</span>
											<span class="countdown_block">{{ timeData.minutes }}</span>
											<span class="countdown_colon">:</span>
											<span class="countdown_block">{{ timeData.seconds }}</span>
										</template>
									</van-count-down>
									<div class="stat_desc">{{ $t('utils.cycle') }}</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
/**
 * 我的投资订单页面组件
 * 显示投资统计数据和订单列表
 */
import Vue from "vue";
import { Empty, CountDown, Icon } from "vant";
import Fetch from "../../utils/fetch";

Vue.use(Empty).use(CountDown).use(Icon);

export default {
	name: "order",
	/**
	 * 组件数据
	 * @returns {Object} 数据对象
	 * @returns {string} lang - 当前语言
	 * @returns {Object} data - 订单数据（含统计和列表）
	 * @returns {boolean} empty - 是否显示空状态
	 */
	data() {
		return {
			lang: this.$i18n.locale || "zh_cn",
			data: {},
			empty: false,
		};
	},
	created() {
		this.$parent.footer("order");
	},
	mounted() {
		this.loadData();
	},
	methods: {
		/**
		 * 加载订单数据
		 * 获取投资统计和订单列表
		 */
		loadData() {
			Fetch("/user/order").then((r) => {
				this.data = r.data;
				this.empty = r.data.list.length == 0;
			});
		},
	},
};
</script>

<style lang="less" scoped>
/**
 * 我的投资订单页面样式
 * 采用卡片式设计，与其他页面保持一致的视觉风格
 */
.order_wrap {
	min-height: 100vh;
	background-color: #f5f5f5;
	padding-bottom: 20px;
}

/* 顶部背景 */
.red_top_bg {
	// height: 168px;
	// background-image: url(../images/user/moneybag/bg.png);
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	z-index: 10;
	background-position: center;
	background-repeat: no-repeat;
	background-size: 100% 100%;
}

/* 数据统计卡片 */
.stats_card {
	display: flex;
	margin: 74px 15px 0;
	background: #fff;
	border-radius: 12px;
	padding: 20px 10px;
	box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08);
	position: relative;
	z-index: 11;

	.stat_item {
		flex: 1;
		text-align: center;
		border-right: 1px solid #f0f0f0;

		&:last-child {
			border-right: none;
		}

		.stat_value {
			font-size: 18px;
			font-weight: 600;
			color: #ff5252;
			margin-bottom: 6px;
		}

		.stat_label {
			font-size: 12px;
			color: #999;
		}
	}
}

/* 订单列表区域 */
.order_section {
	margin: 20px 15px;
	background: #fff;
	border-radius: 12px;
	box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
	overflow: hidden;

	.section_title {
		display: flex;
		align-items: center;
		padding: 16px 20px;
		border-bottom: 1px solid #f5f5f5;

		.van-icon {
			font-size: 18px;
			color: #ff5252;
			margin-right: 8px;
		}

		span {
			font-size: 16px;
			font-weight: 600;
			color: #333;
		}
	}
}

/* 订单列表 */
.order_list {
	.order_item {
		border-bottom: 1px solid #f5f5f5;

		&:last-child {
			border-bottom: none;
		}

		/* 订单头部 */
		.order_header {
			display: flex;
			justify-content: space-between;
			align-items: center;
			padding: 12px 20px;
			background: #f9f9f9;

			.order_time {
				font-size: 13px;
				color: #999;
			}

			.order_status {
				font-size: 12px;
				padding: 4px 12px;
				border-radius: 20px;
				font-weight: 500;

				&.pending {
					background: rgba(255, 82, 82, 0.1);
					color: #ff5252;
				}

				&.completed {
					background: rgba(68, 189, 100, 0.1);
					color: #44bd64;
				}
			}
		}

		/* 订单内容 */
		.order_content {
			display: flex;
			padding: 16px 20px;

			.order_icon {
				width: 48px;
				height: 48px;
				border-radius: 10px;
				overflow: hidden;
				margin-right: 15px;
				flex-shrink: 0;

				img {
					width: 100%;
					height: 100%;
					object-fit: cover;
				}
			}

			.order_info {
				flex: 1;
				min-width: 0;

				.order_name {
					font-size: 15px;
					font-weight: 600;
					color: #333;
					margin-bottom: 12px;
					overflow: hidden;
					text-overflow: ellipsis;
					white-space: nowrap;
				}

				.order_stats {
					display: flex;
					justify-content: space-between;

					.stat {
						text-align: center;

						.stat_num {
							font-size: 14px;
							font-weight: 600;
							color: #333;
							margin-bottom: 4px;

							&.income {
								color: #ff5252;
							}
						}

						.stat_desc {
							font-size: 11px;
							color: #999;
						}
					}
				}
			}
		}
	}
}

/* 倒计时样式 */
.countdown {
	display: flex;
	align-items: center;
	justify-content: center;
	margin-bottom: 4px;

	.countdown_block {
		display: inline-block;
		width: 22px;
		height: 22px;
		line-height: 22px;
		font-size: 12px;
		font-weight: 600;
		color: #333;
		background: #f0f0f0;
		border-radius: 4px;
		text-align: center;
	}

	.countdown_colon {
		margin: 0 2px;
		color: #999;
		font-size: 12px;
	}
}
</style>
